import React from 'react'
import {Badge, Card} from 'react-bootstrap'

const HelpArticleCard = ({article, onClick}) => {
  return (
    <Card
      className='h-100 cursor-pointer shadow-sm border-hover-primary'
      onClick={() => onClick(article)}
      style={{cursor: 'pointer', transition: 'box-shadow 0.2s'}}
    >
      {article.thumbnailUrl && (
        <Card.Img
          variant='top'
          src={article.thumbnailUrl}
          alt={article.title}
          style={{height: '160px', objectFit: 'cover'}}
        />
      )}
      <Card.Body className='d-flex flex-column'>
        <div className='mb-2'>
          <Badge bg='light' text='dark' className='border'>
            {article.category}
          </Badge>
        </div>
        <Card.Title className='fs-6 fw-bold text-dark mb-2'>{article.title}</Card.Title>
        <Card.Text
          className='text-muted fs-7 flex-grow-1'
          style={{
            display: '-webkit-box',
            WebkitLineClamp: 3,
            WebkitBoxOrient: 'vertical',
            overflow: 'hidden',
          }}
        >
          {article.summary}
        </Card.Text>
        <div className='mt-3 text-muted fs-8'>
          <i className='bi bi-list-ol me-1'></i>
          {article.steps.length} adım
        </div>
      </Card.Body>
    </Card>
  )
}

export {HelpArticleCard}
